// extracted by mini-css-extract-plugin
export default {"root":"PrizePage_root__6DoUe","main":"PrizePage_main__v65sU"};